import { z } from 'zod';

export const LoggedModelEntrySchema = z.object({
  run_id: z.string(),
  artifact_path: z.string(),
  utc_time_created: z.string().optional(),
  flavors: z.record(z.string(), z.unknown()).default({}),
});

export const LoggedModelHistorySchema = z.array(LoggedModelEntrySchema);

export type LoggedModelEntry = z.infer<typeof LoggedModelEntrySchema>;

export type ParsedLoggedModel = {
  type: 'logged';
  name: string;
  artifact_path: string;
  run_id: string;
};

export const parseLogModelHistory = (logModelHistoryValue: string): ParsedLoggedModel[] => {
  const models: ParsedLoggedModel[] = [];

  try {
    const parseResult = LoggedModelHistorySchema.safeParse(JSON.parse(logModelHistoryValue));

    if (parseResult.success) {
      const artifactPathMap = new Map<string, LoggedModelEntry>();

      parseResult.data.forEach((entry) => {
        const { artifact_path, utc_time_created } = entry;
        const existing = artifactPathMap.get(artifact_path);

        if (!existing || (utc_time_created && new Date(utc_time_created) > new Date(existing.utc_time_created || 0))) {
          artifactPathMap.set(artifact_path, entry);
        }
      });

      artifactPathMap.forEach((entry) => {
        const flavors = entry.flavors;
        const flavorNames = Object.keys(flavors).filter((f) => f !== 'python_function');

        if (flavorNames.length > 0) {
          models.push({
            type: 'logged',
            name: flavorNames[0],
            artifact_path: entry.artifact_path,
            run_id: entry.run_id,
          });
        }
      });
    } else if (process.env.NODE_ENV === 'development') {
      console.warn('[parseLogModelHistory] Invalid log-model.history structure:', parseResult.error.format());
    }
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[parseLogModelHistory] Failed to parse mlflow.log-model.history:', error);
    }
  }

  return models;
};
